import React, { useState } from 'react'
import { withRouter } from 'react-router-dom'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import {
  Btn,
  CustomCalendar,
  CustomPanel,
  PageHeader,
  SelectEmpresas,
} from '../../../../components'
import { parseToMysqlFormat, getPeriodoMesAtual } from '../../../../services/util/date.service'
import { authHttp } from '../../../../services/api/https/http'
import { urlOperationCentersCyclesByCompany } from '../../../../services/api/routes/system.routes'
import { errorHandler } from '../../../../services/util/error.service'

function EmpresasCentralOperacoes({ history }) {
  // Estados locais
  const [companyId, setCompanyId] = useState(null)
  const [pInicial, setPInicial] = useState(getPeriodoMesAtual().dataInicial)
  const [pFinal, setPFinal] = useState(getPeriodoMesAtual().dataFinal)
  const [operationCenters, setOperationCenters] = useState([])
  const [loading, setLoading] = useState(false)
  const [searched, setSearched] = useState(false)

  const onBuscarClick = async () => {
    if (!companyId) {
      alert('Selecione uma empresa.')
      return
    }

    if (!pInicial || !pFinal) {
      alert('Preencha as datas Inicial e Final.')
      return
    }

    setLoading(true)
    try {
      const dataInicial = parseToMysqlFormat(pInicial)
      const dataFinal = parseToMysqlFormat(pFinal)

      const url = urlOperationCentersCyclesByCompany(companyId, dataInicial, dataFinal)
      const response = await authHttp().get(url)

      setOperationCenters(response.data)
      setSearched(true)
    } catch (error) {
      alert('Erro ao buscar dados: ' + errorHandler(error))
    } finally {
      setLoading(false)
    }
  }

  return (
    <React.Fragment>
      <PageHeader>S.30 - Empresas X Central de Operações</PageHeader>
      <div style={{ marginTop: 20 }}>
        <CustomPanel onVoltar={history.goBack} showBtnNovo={false}>
          <div className="p-grid" style={{ alignItems: 'flex-end' }}>
            <div className="p-col-12 p-md-4">
              <SelectEmpresas
                companyId={companyId}
                onChange={company => setCompanyId(company ? company.id : null)}
              />
            </div>

            <CustomCalendar
              label="Período Inicial"
              value={pInicial}
              onChange={value => setPInicial(value)}
            />

            <CustomCalendar
              label="Período Final"
              value={pFinal}
              onChange={value => setPFinal(value)}
            />

            <div className="p-col-12 p-md-2" style={{ paddingBottom: 8 }}>
              <Btn onClick={onBuscarClick} disabled={loading}>
                {loading ? 'Buscando...' : 'Buscar'}
              </Btn>
            </div>
          </div>

          {searched && (
            <div className="p-grid" style={{ marginTop: 20 }}>
              <div className="p-col-12">
                <DataTable
                  value={operationCenters}
                  paginator
                  rows={10}
                  emptyMessage="Não existe ciclo associado a essa empresa no período selecionado"
                  responsive
                >
                  <Column field="operationcenter_name" header="Central de Operações" sortable />
                  <Column
                    field="quantidade_ciclos"
                    header="Qtd Ciclos"
                    sortable
                    style={{ textAlign: 'center', width: '150px' }}
                    body={rowData => rowData.quantidade_ciclos || 0}
                  />
                  <Column
                    field="quantidade_entregas"
                    header="Qtd Entregas"
                    sortable
                    style={{ textAlign: 'center', width: '150px' }}
                    body={rowData => rowData.quantidade_entregas || 0}
                  />
                </DataTable>
              </div>
            </div>
          )}
        </CustomPanel>
      </div>
    </React.Fragment>
  )
}

export default withRouter(EmpresasCentralOperacoes)
